module.exports = "https://static-production.npmjs.com/20c188a1399358a9af0a4a4b25530a4e.svg";